import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Box, Typography } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

export const ContainerBody = styled.div(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    display: flex;
    flex-direction: column;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        &.changed-payment {
            padding-bottom: 2.1875rem;
        }
    }
`);

export const ContentBody = styled.div(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    display: flex;
    flex-direction: column;
`);

export const ContentInvoices = styled.div(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    display: flex;
    padding-top: .625rem;
    flex-direction: column;
`);

// export const LinkCustom = styled(Link)(
//     ({ theme }: ParamsStyle) => `
//     width: 100%;
//     display: flex;
//     height: 7.7rem;
//     max-width: 14rem;
//     align-items: center;
//     margin-top: .9375rem;
//     flex-direction: column;
//     border-radius: 10.6202px;
//     justify-content: space-between;
//     border: 1.18506px solid ${theme?.palette.primary.main};
// `);

export const BoxCustom = styled(Box)(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    display: flex;
    height: 7.7rem;
    max-width: 14rem;
    align-items: center;
    margin-top: .9375rem;
    flex-direction: column;
    border-radius: 10.6202px;
    justify-content: space-between;
    border: 1.18506px solid ${theme?.palette.primary.main};
`);

export const TypographyTitle = styled(Typography)(
    ({ theme }: ParamsStyle) => `
        font-size: .75rem;
        line-height: 1rem;
        margin-bottom: .25rem;

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            border-bottom: 1px solid rgba(141, 155, 181, 0.35);
        }                         
`);

export const ContentDetails = styled(Box)(
    ({ theme }: ParamsStyle) => `
        min-height: 0;
        border-right: none;
        border-bottom: 1px solid #8D9BB5;

        &.no-border {
            border-bottom: none;
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            border-bottom: none;
            min-height: 7.81rem;
            border-right: 1px solid #8D9BB5;

            &.no-border {
                border-right: none;
            }
        }                         
`);

export const LinkExtermal = styled('a')(
    ({ theme }: ParamsStyle) => `
    font-size: .9375rem;
    position: relative;
    font-weight: 700;
    color: white;
    display: flex;
    height: 40px;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    border: 2px solid #FFFFFF;
    margin-bottom: .9375rem;
    
    svg {
        position: absolute;
        right: 1.25rem;
        height: 1.2rem;
    }
`);